import React from 'react'
import "./AppDownload.css"
import {assets} from "../../assets/assets"
const AppDownload = () => {
  return (
    <div className='app-download' id='app-download'>
<p> Coming soon!   <br /> For Enhanced Experience Download </p>

<div className="app-download-platforms">

 <img src={assets.play_store} alt="rootzbaite miraa nairobi" />
 <img src={assets.app_store} alt="miraa delivery nairobi rootzbaite" />

</div>





    </div>
  )
}

export default AppDownload